export default __webpack_public_path__ + "static/personbilsutbildning-d4c04be1a0642e0ad3aad8aa6c3f3b05.jpg";